import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AuthService } from '../shared/services/auth.service';
import { Router } from '@angular/router';
import '../../style/app.scss';
import { UserService } from '../shared/services/user.service';
import { WindowRefService } from '../shared/services/window-ref.service';

const hostUrl = 'https://dizzee.umusic.com';

@Component({
  selector: 'my-navigation-layout',
  template: require('./navigation.component.html'),
  styles: [require('./navigation.component.scss')]
})

export class NavigationLayoutComponent implements OnInit {
  private isLoggedIn: any;
  public userType: any;
  private _window: Window;

  constructor(
    public authService: AuthService,
    private location: Location,
    private router: Router,
    public windowRef: WindowRefService,
    public userService: UserService
  ){
    this.isLoggedIn = false;
    this.userType = this.authService.userLoginType;
    this._window = windowRef.nativeWindow;
  }

  logout(){
    // console.log('logging out');
    this.authService.isLoggedIn.next(false);
    this._window.location.href = hostUrl + '/service/logout';
  }

  login(){
    // console.log('logging in');
    this._window.location.href = hostUrl + '/service/login';
  }

  navigateTo(dest: string) {
    let test = this.location.path().split('?')[1];
    let query = dest + '?' + test;
    if (test !== undefined) {
      this.router.navigateByUrl(query);
    } else {
      this.router.navigateByUrl(dest);
    }
  }


  ngOnInit(){
    this.authService.isLoggedIn.subscribe(e => {
      if(e != null) {
        this.isLoggedIn = e;
      } else {
        this.isLoggedIn = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./src/app/layout/navigation.component.ts